import API_URL from "./config";

const BE_API_URL = `${API_URL}/api-recruitment`;

window.onload = function() {
  fetch(`${BE_API_URL}/docusign/settings`)
    .then((res) => res.json())
    .then((data) => {
      const docusignScriptUrl = data.docusign_url;
      
      if (docusignScriptUrl) {
        const script = document.createElement('script');
        script.src = docusignScriptUrl;
        document.head.appendChild(script);
      } else {
        console.error("DocuSign URL not found in the response.");
      }
    })
    .catch((err) => {
      console.error('Failed to fetch DocuSign settings:', err);
    });
};